import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../environments/environment';

export const adminGuard = () => {
  const keycloak = inject(KeycloakService);
  const router = inject(Router);

  const clientRoles = keycloak.getUserRoles(false, environment.keycloak.clientId);
  if (clientRoles.some(role => role.toUpperCase() === 'ADMIN')) {
    return true;
  }

  return router.parseUrl('/coletas');
};
